// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c01f00fc","977":"5777e25f"}[chunkId] + ".chunk.js";
};